import { apiAction, API_ERROR, API_SUCCESS } from "../dux/api";
import { apiCallComplete, apiCallStart } from "../dux/apiStatus";
import {
  logInUser,
  REGISTER_USER,
  SEND_MOBILE_NUMBER,
  SEND_OTP,
  setOtpIncorrect,
  setOtpRecieved,
  setRegisteredFlag,
  setUserExist,
  setUserInvalid,
  setUserDeactivated,
} from "../dux/login";
import { hidePrompt, showPrompt } from "../dux/prompt";
import { openSnackbar } from "../dux/snackbar";
import { promptCategoryType } from "../helpers/constants";
import {
  getLoginWithOtpUrl,
  getVerifyOtpUrl,
  getRegisterUserUrl,
} from "../helpers/apiEndPoints";
import { startSession } from "../helpers/sessionStorageHelper";

const login = () => (next) => (action) => {
  next(action);

  // to get otp
  if (action.type === SEND_MOBILE_NUMBER) {
    next(apiCallStart({ api: "getOtp" }));
    next(
      apiAction({
        url: getLoginWithOtpUrl(),
        feature: SEND_MOBILE_NUMBER,
        method: "POST",
        data: { mobile_number: action.payload.mobileNumber },
      })
    );
  }

  if (action.type === `${SEND_MOBILE_NUMBER} ${API_SUCCESS}`) {
    next(apiCallComplete({ api: "getOtp" }));
    next(setOtpRecieved());
  }

  if (action.type === `${SEND_MOBILE_NUMBER} ${API_ERROR}`) {
    next(apiCallComplete({ api: "getOtp" }));
    if (action?.payload?.data?.status === 404) {
      next(setUserInvalid());
    } else if (
      action?.payload?.data?.status === 400 &&
      action?.payload?.data?.response?.message?.includes(
        "user has been inactive"
      )
    ) {
      next(setUserDeactivated());
    } else {
      next(showPrompt({ category: promptCategoryType.GENERIC_ERROR }));
    }
  }

  //verify otp
  if (action.type === SEND_OTP) {
    next(apiCallStart({ api: "verifyOtp" }));
    next(
      apiAction({
        url: getVerifyOtpUrl(),
        feature: SEND_OTP,
        method: "POST",
        data: {
          mobile_number: action.payload.mobileNumber,
          mobile_otp: action.payload.mobileOtp,
        },
      })
    );
  }

  if (action.type === `${SEND_OTP} ${API_SUCCESS}`) {
    next(apiCallComplete({ api: "verifyOtp" }));
    const resp = action.payload.response;
    const sessionObj = {
      access_token: resp.access_token,
      refresh_token: resp.refresh_token, // store refresh token
      userData: resp.user_data || resp.userData, // support both keys
    };
    startSession(JSON.stringify(sessionObj));
    next(logInUser());
    next(hidePrompt());
    next(openSnackbar({ message: "User Logged In Successfully" }));
  }

  if (action.type === `${SEND_OTP} ${API_ERROR}`) {
    next(apiCallComplete({ api: "verifyOtp" }));
    if (action?.payload?.data?.status === 403) {
      next(setOtpIncorrect());
    } else {
      next(showPrompt({ category: promptCategoryType.GENERIC_ERROR }));
    }
  }

  if (action.type === REGISTER_USER) {
    next(apiCallStart({ api: "registerUser" }));
    const { firstName, lastName, emailAddress, mobileNumber } = action.payload;
    next(
      apiAction({
        url: getRegisterUserUrl(),
        feature: REGISTER_USER,
        method: "POST",
        data: {
          first_name: firstName,
          last_name: lastName,
          email_address: emailAddress,
          mobile_number: mobileNumber,
        },
      })
    );
  }

  if (action.type === `${REGISTER_USER} ${API_SUCCESS}`) {
    next(apiCallComplete({ api: "registerUser" }));
    next(setRegisteredFlag());
  }

  if (action.type === `${REGISTER_USER} ${API_ERROR}`) {
    next(apiCallComplete({ api: "registerUser" }));
    if (
      action?.payload?.data?.status === 400 &&
      action?.payload?.data?.response?.message?.includes(
        "user has been inactive"
      )
    ) {
      next(setUserDeactivated());
    } else if (action?.payload?.data?.status === 403) {
      next(setUserExist());
    } else {
      next(showPrompt({ category: promptCategoryType.GENERIC_ERROR }));
    }
  }
};

export default login;
